import React from 'react';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';

const ProImpersonationLogoutButton = () => (
  <Button
    version="v2"
    color="error"
    variant="contained"
    href="/impersonates"
    data-method="delete"
  >
    HCP log out
  </Button>
);

export default ProImpersonationLogoutButton;
